$ = jQuery.noConflict(true);
 
// **************
// Add scroll class to Nav when scrolling
// **************

// Define nav
var mainNav = document.querySelector('.site-header');

// Trigger scroll function
window.onscroll = function() {
  windowScroll();
};

// Scroll function
function windowScroll() {
    mainNav.classList.toggle("sh-scroll", mainNav.scrollTop > 40 || document.documentElement.scrollTop > 40);
}

// **************
// function for navigating to specific #
// **************
let navHeight = $(".main-navigation").height();

$('a[href*="#"]').on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({
    scrollTop: $($(this).attr('href')).offset().top - navHeight - 60,
  },700,'swing');
});

// **************
// Mobile menu open function
// **************
$('.menu-toggle').click(function(e) {
  $('.nav').addClass('scroll');
  $(this).toggleClass('menu-toggle-active');
  $('.main-navigation').toggleClass('__nav-active');
  
  e.preventDefault();
});

// **************
// Video Popup
// **************

// Open
$('.popup-box').click(function () {
  $('.video-popup').toggleClass('vp-active');
});

// Close
$('.video-popup').click(function () {
    $(this).removeClass('vp-active');
    $('iframe').attr('src', $('iframe').attr('src'));
});

// **************
// Quick contact action button revealing a form
// **************
$('a.qct').click(function (e) {
  $('.interaction').toggleClass('__hide');
  $('.cqform .nf-form-cont ').toggleClass('__visible');

  e.preventDefault();
});

// **************
// Slick hero places (plaatsen)
// **************
if($(".hero-places")[0]){
  $('.hero-places').slick({
    centerMode: true, 
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2200,
    variableWidth: true, 
    arrows: false,
    slickPause: false
  });
}

// **************
// Slick reviews
// **************
if($(".mlb-reviews")[0]){
  $('.mlb-reviews').on('init', function(event){
    var reviewDataSrc = $('.mlb-reviews .slick-current');
    var reviewAuthor = reviewDataSrc.data("author");
    var reviewDate = reviewDataSrc.data("date");
    
    $("#author").text(reviewAuthor);
    $("#date").text(reviewDate);

  });

  // After slide change (author, date)
  $('.mlb-reviews').on('afterChange', function(event){
    var reviewDataSrc = $('.mlb-reviews .slick-current');
    var reviewAuthor = reviewDataSrc.data("author");
    var reviewDate = reviewDataSrc.data("date");

    $("#author").fadeOut(200, function() {
      $(this).text(reviewAuthor).fadeIn(200);
    });
    $("#date").fadeOut(200, function() {
      $(this).text(reviewDate).fadeIn(200);
    });
  });

  // Load slick
  $('.mlb-reviews').slick({
    infinite: true,
    adaptiveHeight: true,
    arrows: true,
    prevArrow: '.rv-prv',
    nextArrow: '.rv-nxt',
    dots: true,
    appendDots: '.reviews-nav',
    slidesToShow: 1,
    slidesToScroll: 1
  });
} 

// **************
// Slick services (cards)
// **************
if($(".slick-service")[0]){

  // Initialize slick
  // onload event: if smaller screen
  // then set slides to equal height
  $('.slick-service').slick({
    arrows: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick"
      },
      {
        breakpoint: 767,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            accessibility: false,
            mobileFirst: true
        }
      }]
  }).on('setPosition', function (event, slick) {
    if (window.matchMedia("(max-width: 767px)").matches) {
      slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    }
  });

  // Reinit slider on resize
  $(window).on('resize orientationchange', function() {
    if (window.matchMedia("(max-width: 767px)").matches) {
      $('.slick-service').slick('refresh');
    }
  });
}